import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import HeaderBread from "../../../../../../components/HeaderBread";
import CustomHeaderTitle from "../../../../../../components/constants/CustomHeaderTitle";
import Layout from "../../../../../../Layout";
import EntertainmentItemizerInput from "../../../../../../components/EntertainmentItemizerInput";
import { useDataLayerValue } from "../../../../../../DataLayer/DataLayer";
import { getEntertainmentRvc } from "../../../../../../utils/ApiCalls/BackOffice/Entertainment";

const LIST_PATH = "/shore/back-office/entertainment/revenue-center";

const CreateItemizer = () => {
  const params = useParams();
  const navigate = useNavigate();
  const [rvc, setRvc] = useState(null);
  const [, dispatch] = useDataLayerValue();

  useEffect(() => {
    const loadRvc = async () => {
      dispatch({ type: "SET_LOADING", loading: true });
      const data = await getEntertainmentRvc(params.id);
      if (!data.error) setRvc(data);
      dispatch({ type: "SET_LOADING", loading: false });
    };
    loadRvc();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.id]);

  const basePath = `${LIST_PATH}/${params.id}`;

  const navigation = [
    { title: "Home", route: "/" },
    { title: "Revenue Center", route: LIST_PATH },
    { title: rvc?.name || "Revenue Center", route: basePath },
    { title: "Add Itemizer", route: `${basePath}/itemizer/add` },
  ];

  return (
    <Layout type={"create_per"} module_data={"Revenue Center"}>
      <CustomHeaderTitle title={"Create Itemizer"} />
      <HeaderBread navigation={navigation} title={"Add Itemizer"}></HeaderBread>
      {rvc && (
        <EntertainmentItemizerInput
          rvcId={rvc.id}
          rvcName={rvc.name}
          itemizer={{}}
          onSuccess={() =>
            navigate(basePath, { state: { topTab: "itemizer" } })
          }
        />
      )}
    </Layout>
  );
};

export default CreateItemizer;
